import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../auth';
import { filter, map, take } from 'rxjs';
import { ERROR_ROUTE } from '../error/_consts/error-route.const';

export const operatorGuard: CanActivateFn = (route, state) => {
  const auth = inject(AuthService);
  const router = inject(Router)

  return auth.user$.pipe(
    filter((result) => result != null),
    take(1),
    map((result) => {
      if(!AuthService.isOperatorUser(result)) {
        router.navigateByUrl(`/${ERROR_ROUTE}/404`)
      }
      return AuthService.isOperatorUser(result);
    })
  );
}